import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Router,} from "react-router-dom"; 
import React , {useEffect, useState} from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import Body from './pages/Body';
import Login from './pages/login';
import Registration from './pages/Registration';
import Dashboard from './pages/Dashboard';
import Tower from './pages/tower';
import { commonAPI } from './services/CommonAPIService';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Building from './pages/building';
import Client from './pages/client';
import Menus from './pages/menus';
import Noticemanagement from './pages/Noticemanagement';
import Management from './pages/Management';
import Gate from './pages/Gate';
import Flat from './pages/flat';
import NoticeApproval from './pages/NoticeApproval';
import Familydetails from './pages/Familydetails';
import UserApproval from './pages/UserApprove';
import Approval from './pages/Approval';
import vehicleApproval from './pages/vehicleApproval';
import Resident from './pages/Resident';
import Configuration from './pages/Configuration';
import Report from './pages/Report';
import Utility from './pages/Utility';
import Profile from './pages/Profile';
import VisitorLinkPage from './pages/VisitorLinkPage/visitoLinkpage';
import GlobalConfiguration from './pages/GlobalConfiguration';
import ManageRfid from './pages/ManageRFID';
import ClearSessionWrapper from './components/ClearSessionWrapper';
import DeleteAccount from './pages/DeleteAccount';
import SelectBuilding from './pages/selectBuilding';
import SystemSetting from './pages/SystemSetting';
import Helpdesk from './pages/Helpdesk';
import ComplaintDashboard from './pages/ComplaintDashboard';
import InvitePage from './pages/VisitorLinkPage/groupInvite';


function App() {
 
  const [data, setData] = useState([]);
  // console.log = () => {};
  // console.error = () => {};
  // console.warn = () => {};

  return (
   
    <BrowserRouter>
     <ClearSessionWrapper>
      <Routes>
        {/* <IndexRedirect to="/Building" /> */}
        <Route path="/" element={<Login/>} />
        <Route path="/Body" element={<Body/>} />
        <Route path="/Dashboard" element={<Dashboard/>} />
        <Route path="/Building" element={<Building/>} />
        <Route path="/Client" element={<Client/>}></Route>
        <Route path="/Registration" element={<Registration/>}></Route>
        <Route path="/Notice" element={<Noticemanagement/>}></Route>
        <Route path="/Gate" element={<Gate/>}></Route>
        <Route path="/Helpdesk" element={<Helpdesk/>}></Route>
        <Route path="/Flat" element={<Flat/>}></Route>
        <Route path="/Tower" element={<Tower/>}></Route>
        <Route path="/NoticeApproval" element={<NoticeApproval/>}></Route>
        <Route path="/Configuration" element={<Configuration/>}></Route>
        <Route path="/GlobalConfiguration" element={<GlobalConfiguration/>}></Route>
        <Route path="/Approval" element={<Approval/>}></Route>
        <Route path="/UserApproval" element={<UserApproval/>}></Route>
        <Route path="/Resident" element={<Resident  />}></Route>
        <Route path="/Familydetails" element={<Familydetails  />}></Route>
        <Route path="/ComplaintDashboard" element={<ComplaintDashboard/>}></Route>
        <Route path="/Management" element={<Management  />}></Route>
        <Route path="/SystemSetting" element={<SystemSetting  />}></Route>
        <Route path="/vehicleApproval" element={<vehicleApproval/>}></Route>
        <Route path="/Report" element={<Report/>}></Route>
        <Route path="/Utility" element={<Utility/>}></Route>
        <Route path="/Profile" element={<Profile/>}></Route>
        <Route path="/inv" element={<VisitorLinkPage/>}></Route>
        <Route path="/passInv" element={<VisitorLinkPage/>}></Route>
        <Route path="/ManageRfid" element={<ManageRfid/>}></Route>
        <Route path="/Account" element={<DeleteAccount/>}></Route>
        <Route path="/SelectBuilding" element={<SelectBuilding/>}></Route>
        <Route path="/ginv" element={<InvitePage/>}></Route>
      </Routes>
      </ClearSessionWrapper>
  </BrowserRouter>
// </ClearSessionWrapper>
  );
}

export default App;
